import { EntityName } from '@adm/backend-entity';

import { Models, UserRole } from '../enums';
import {
  brandPermissions,
  cityPermissions,
  colorPermissions,
  configurationPermissions,
  customerPermissions,
  devicePermissions,
  equipmentPermissions,
  eventsHistoryPermissions,
  facilityPermissions,
  generationColorPermissions,
  generationPermissions,
  glossaryPermissions,
  localePermissions,
  modelPermissions,
  notificationPermissions,
  notificationTemplatePermissions,
  ownershipPermissions,
  partnerPermissions,
  providerPermissions,
  reportPermissions,
  simCardPermissions,
  storyPageViewPermissions,
  storyPermissions,
  subscriptionPermissions,
  tariffPermissions,
  ticketPermissions,
  userPermissions,
  vehiclePermissions,
} from './models-permissions';

import { Actions } from './actions.config';

function getRolePermissions(
  role: UserRole,
): { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[] {
  return [
    ...brandPermissions[role],
    ...colorPermissions[role],
    ...configurationPermissions[role],
    ...customerPermissions[role],
    ...devicePermissions[role],
    ...equipmentPermissions[role],
    ...eventsHistoryPermissions[role],
    ...generationColorPermissions[role],
    ...generationPermissions[role],
    ...modelPermissions[role],
    ...ownershipPermissions[role],
    ...partnerPermissions[role],
    ...simCardPermissions[role],
    ...storyPermissions[role],
    ...subscriptionPermissions[role],
    ...tariffPermissions[role],
    ...userPermissions[role],
    ...vehiclePermissions[role],
    ...notificationPermissions[role],
    ...glossaryPermissions[role],
    ...notificationTemplatePermissions[role],
    ...cityPermissions[role],
    ...localePermissions[role],
    ...storyPageViewPermissions[role],
    ...ticketPermissions[role],
    ...reportPermissions[role],
    ...facilityPermissions[role],
    ...providerPermissions[role],
  ];
}

export const adminPermissions = [
  ...getRolePermissions(UserRole.Admin),
  { actions: [Actions.manage], subject: Models.All },
];
export const operatorPermissions = getRolePermissions(UserRole.Operator);
export const operatorWithoutPBAccessPermissions = getRolePermissions(UserRole.OperatorWithoutPBAccess);
export const deviceOperatorPermissions = getRolePermissions(UserRole.DeviceOperator);
export const readOperatorPermissions = getRolePermissions(UserRole.OperatorReadAccess);
export const ttmOperatorPermissions = getRolePermissions(UserRole.TtmOperator);
export const deviceQualityOperatorPermissions = getRolePermissions(UserRole.DeviceQualityOperator);
